/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { parseJsonDateAsUtc } from '../../utils/apiDateTime';
import type { RevisdomAPIViewModelsUserResponse } from './RevisdomAPIViewModelsUserResponse';
import {
    RevisdomAPIViewModelsUserResponseFromJSON,
    RevisdomAPIViewModelsUserResponseFromJSONTyped,
    RevisdomAPIViewModelsUserResponseToJSON,
    RevisdomAPIViewModelsUserResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryFolderResponse
 */
export interface RevisdomAPIViewModelsEntryFolderResponse {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    parentId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    projectId?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    status?: RevisdomAPIViewModelsEntryFolderResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    entryType?: RevisdomAPIViewModelsEntryFolderResponseEntryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    thumbnailUrl?: string | null;
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsUserResponse>}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    share?: Array<RevisdomAPIViewModelsUserResponse> | null;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    totalSizeInBytes?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryFolderResponse
     */
    childrenEntryCount?: number;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsEntryFolderResponseStatusEnum = {
    NeedsReview: 'NeedsReview',
    Updated: 'Updated',
    Approved: 'Approved'
} as const;
export type RevisdomAPIViewModelsEntryFolderResponseStatusEnum = typeof RevisdomAPIViewModelsEntryFolderResponseStatusEnum[keyof typeof RevisdomAPIViewModelsEntryFolderResponseStatusEnum];

/**
 * @export
 */
export const RevisdomAPIViewModelsEntryFolderResponseEntryTypeEnum = {
    Project: 'Project',
    Folder: 'Folder',
    File: 'File',
    Version: 'Version'
} as const;
export type RevisdomAPIViewModelsEntryFolderResponseEntryTypeEnum = typeof RevisdomAPIViewModelsEntryFolderResponseEntryTypeEnum[keyof typeof RevisdomAPIViewModelsEntryFolderResponseEntryTypeEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryFolderResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryFolderResponse(value: object): value is RevisdomAPIViewModelsEntryFolderResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryFolderResponseFromJSON(json: any): RevisdomAPIViewModelsEntryFolderResponse {
    return RevisdomAPIViewModelsEntryFolderResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryFolderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryFolderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'id': json['id'] == null ? undefined : json['id'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'name': json['name'] == null ? undefined : json['name'],
        'path': json['path'] == null ? undefined : json['path'],
        'status': json['status'] == null ? undefined : json['status'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'share': json['share'] == null ? undefined : ((json['share'] as Array<any>).map(RevisdomAPIViewModelsUserResponseFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (parseJsonDateAsUtc(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseJsonDateAsUtc(json['updatedAt'])),
        'totalSizeInBytes': json['totalSizeInBytes'] == null ? undefined : json['totalSizeInBytes'],
        'childrenEntryCount': json['childrenEntryCount'] == null ? undefined : json['childrenEntryCount'],
    };
}

export function RevisdomAPIViewModelsEntryFolderResponseToJSON(json: any): RevisdomAPIViewModelsEntryFolderResponse {
    return RevisdomAPIViewModelsEntryFolderResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryFolderResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryFolderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parentId': value['parentId'],
        'id': value['id'],
        'projectId': value['projectId'],
        'name': value['name'],
        'path': value['path'],
        'status': value['status'],
        'entryType': value['entryType'],
        'thumbnailUrl': value['thumbnailUrl'],
        'share': value['share'] == null ? undefined : ((value['share'] as Array<any>).map(RevisdomAPIViewModelsUserResponseToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
        'totalSizeInBytes': value['totalSizeInBytes'],
        'childrenEntryCount': value['childrenEntryCount'],
    };
}

